import formatTableJson from '@/config/tableComponentParams.js'
import { enbaleDisableStatus } from '@/config/status'
export default formatTableJson([
  {
    filed: 'name',
    label: '名称',
    width: '180px'
  },
  {
    filed: 'distributorName',
    label: '所属渠道商',
    width: '180px'
  },
  {
    filed: 'status',
    label: '状态',
    type: 'status',
    statusProps: enbaleDisableStatus,
    formatFn: function(_, row) {
      return row.statusName
    }
  },
  {
    filed: 'principal',
    label: '负责人',
    width: '200px'
  },
  {
    filed: 'phone',
    label: '电话'
  },
  {
    filed: 'email',
    label: '邮箱'
  },
  {
    filed: 'address',
    label: '所在地址',
    width: '200px',
    formatFn: function(_, row) {
      return [row.province, row.city, row.region, row.address].filter(Boolean).join('')
    }
  },
  {
    filed: 'expiryDate',
    label: '有效期至',
    type: 'time',
    timeFormat: 'YYYY-MM-DD',
    width: '180px'
  }
])
